import React from 'react';
import { Button } from './ui/Button';
import { fireAddToCart, fireInitiateCheckout } from './MetaPixel';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  const handleCtaClick = () => {
    fireAddToCart();
    fireInitiateCheckout();
  };
  return <div className="relative h-screen w-full overflow-hidden flex items-center justify-center" data-id="element-17">
      {/* Background Video */}
      <div className="absolute inset-0 z-0" data-id="element-18">
        <div className="absolute inset-0 bg-luxury-black/70 z-10" data-id="element-19" />
        <div className="absolute inset-0 bg-gradient-to-t from-luxury-black via-transparent to-luxury-black/40 z-10" data-id="element-20" />
        <video autoPlay loop muted playsInline preload="metadata" className="w-full h-full object-cover opacity-80" data-id="element-21">
          <source src="https://cdn.magicpatterns.com/uploads/3qshraEpEvHFgBe1h2EHep/video%202%20ai%20.mp4" type="video/mp4" data-id="element-22" />
        </video>
      </div>

      {/* Content */}
      <div className="relative z-20 text-center px-6 max-w-4xl mx-auto animate-fade-in-up" data-id="element-23">
        <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white mb-6 leading-tight" data-id="element-24">
          {t.hero.headline.line1} <br data-id="element-25" />
          {t.hero.headline.line2} <br data-id="element-26" />
          <span className="text-gradient-gold italic" data-id="element-27">
            {t.hero.headline.span}
          </span>
        </h1>

        {/* Microproof */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8 text-sm text-luxury-gold/80 uppercase tracking-wider font-medium" data-id="element-28">
          <span className="flex items-center" data-id="element-29">
            <CheckCircle2 className="w-4 h-4 mr-2" data-id="element-30" /> {t.hero.microproof.system}
          </span>
          <span className="flex items-center" data-id="element-31">
            <CheckCircle2 className="w-4 h-4 mr-2" data-id="element-32" />{' '}
            {t.hero.microproof.framework}
          </span>
          <span className="flex items-center" data-id="element-33">
            <CheckCircle2 className="w-4 h-4 mr-2" data-id="element-34" />{' '}
            {t.hero.microproof.results}
          </span>
        </div>

        <p className="text-luxury-gray text-lg md:text-xl max-w-2xl mx-auto mb-10 font-light leading-relaxed" data-id="element-35">
          {t.hero.subheadline}
        </p>

        <div className="flex flex-col items-center" data-id="element-36">
          <Button id="cta-primary" href="https://learn.alexaaanarvaez.in/cart/43580187443265:1" variant="primary" withArrow className="min-w-[280px]" onClick={handleCtaClick} data-id="element-37">
            {t.hero.cta}
          </Button>
          <p className="text-luxury-gray/60 text-xs mt-4 font-light" data-id="element-38">
            {t.hero.trust}
          </p>
        </div>
      </div>
    </div>;
}